import { useTranslation } from 'react-i18next';

import { Tabs } from '@treams/treams-ui';

export default function LaunchAnalyticsTabs() {
	const { t } = useTranslation();

	return (
		<Tabs.Container wide={1080}>
			<Tabs.Item
				title={t('settings.analytics.treams-score', { defaultValue: 'Treams Score' })}
				path="/settings/analytics"
			/>
		</Tabs.Container>
	);
}
